<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
    >
      <v-form @submit.prevent="login">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Prihlásenie</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="username"
              label="Prihlasovacie meno"
              name="login"
              prepend-icon="mdi-account"
              type="text"
            />
            <v-text-field
              id="password"
              v-model="password"
              label="Heslo"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
            />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
              >
                Prihlásiť sa
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      drawer: null,
      username: "",
      password: "",
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },

  methods: {
    login() {
      let username = this.username;
      let password = this.password;

      this.$store
        .dispatch("auth/login", { username, password })
        .then(() => {
          this.$router.push("home");
        })
    },
  },
};
</script>